export default "__VITE_ASSET__dd1264e3__"